import { EventEmitter, Injectable } from '@angular/core';

@Injectable()

export class StorageAccountService {

    isDown: EventEmitter<boolean> = new EventEmitter();

}
